import { memo } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';

export const AirflowTooltipContent = memo(() => (
    <div className="vss-actuators-airflow-tooltip-content">
        <div className="vss-actuators-airflow-tooltip-content__data-cell"/>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            <I18n messageId={MESSAGES.AirflowLow}/>
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            <I18n messageId={MESSAGES.AirflowMid}/>
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            <I18n messageId={MESSAGES.AirflowHigh}/>
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            <I18n messageId={MESSAGES.ParallelBladeWithSeals}/>
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            7
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            10.5
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            14
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            <I18n messageId={MESSAGES.OpposedBladeWithSeals}/>
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            4
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            6
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            8
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            <I18n messageId={MESSAGES.ParallelBladeWithoutSeals}/>
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            5
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            7.5
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            10
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            <I18n messageId={MESSAGES.OpposedBladeWithoutSeals}/>
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            3
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            4.5
        </div>

        <div className="vss-actuators-airflow-tooltip-content__data-cell">
            6
        </div>
    </div>
));
